/* DEMO/STAGING ENVIRONMENT - source of truth for staging credentials.
 *
 * This file is COPIED to ./info.tsx by:
 *   - npm run dev          (predev hook ensures ./info.tsx exists)
 *   - npm run dev:staging  (forces this file to win)
 *   - npm run env:staging  (switch without starting Vite)
 *   - ./deploy.sh staging
 *
 * Edit ONLY this file (and info.production.tsx) to update credentials.
 * Never edit info.tsx directly -- it is gitignored and gets clobbered.
 */

export const projectId = "pturcacflihinxoiphte";
export const publicAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB0dXJjYWNmbGloaW54b2lwaHRlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIzNTkyMzMsImV4cCI6MjA3NzkzNTIzM30.5x-iy2Prq2UR8iHXv4PS9d_VluRBz9fHh_E4sQ_Ut-4";
export const envName = "staging" as const;

// Loud, single-line startup banner so the developer can never be confused
// about which backend localhost:5173 is currently wired to. Runs once when
// info.tsx is first imported (which is the very first thing the app does).
// Suppressed under vitest (MODE === "test") so unit/component tests don't
// pollute their stdout.
if (
  typeof window !== "undefined" &&
  (import.meta as any).env?.MODE !== "test"
) {
  // eslint-disable-next-line no-console
  console.log(
    `%c[ENV] PathKit frontend → ${envName} backend (project: ${projectId})`,
    "color:#b8860b;font-weight:bold",
  );
}
